import React, { useState, useEffect } from 'react';
import { getObjectifs, getObjectifsSuivi, createObjectif, updateObjectif, deleteObjectif, getCommerciaux, getProduits } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { FiPlus, FiEdit2, FiTrash2, FiTarget } from 'react-icons/fi';
import SearchableSelect from '../components/SearchableSelect';

const PERIODES = ['jour', 'semaine', 'mois', 'trimestre', 'annee'];
const TYPES = ['vente', 'commande', 'visite', 'installation', 'sensibilisation', 'inscription', 'recrutement'];

const Objectifs: React.FC = () => {
    const { isManager } = useAuth();
    const [objectifs, setObjectifs] = useState<any[]>([]);
    const [suivi, setSuivi] = useState<any[]>([]);
    const [commerciaux, setCommerciaux] = useState<any[]>([]);
    const [produits, setProduits] = useState<any[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [editObj, setEditObj] = useState<any>(null);
    const [tab, setTab] = useState<'suivi' | 'liste'>('suivi');
    const [form, setForm] = useState<any>({ user_id: '', produit_id: '', type_activite: '', periode: 'mois', date_debut: '', date_fin: '', valeur_cible: '', collectif: 0 });

    useEffect(() => {
        getObjectifsSuivi().then(res => setSuivi(res.data));
        getObjectifs().then(res => setObjectifs(res.data));
        getCommerciaux().then(res => setCommerciaux(res.data));
        getProduits().then(res => setProduits(res.data));
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const data = { ...form, user_id: form.user_id || null, produit_id: form.produit_id || null, type_activite: form.type_activite || null };
        if (editObj) await updateObjectif(editObj.id, data);
        else await createObjectif(data);
        setShowModal(false);
        getObjectifs().then(res => setObjectifs(res.data));
        getObjectifsSuivi().then(res => setSuivi(res.data));
    };

    const handleDelete = async (id: number) => {
        if (window.confirm('Supprimer cet objectif ?')) {
            await deleteObjectif(id);
            getObjectifs().then(res => setObjectifs(res.data));
        }
    };

    const tauxColor = (taux: number) => taux >= 100 ? '#16A34A' : taux >= 75 ? '#3B82F6' : taux >= 50 ? '#F59E0B' : '#EF4444';

    return (
        <div className="page-objectifs">
            <div className="page-header">
                <h2><FiTarget /> Objectifs</h2>
                {isManager() && <button className="btn btn-primary" onClick={() => { setEditObj(null); setForm({ user_id: '', produit_id: '', type_activite: '', periode: 'mois', date_debut: new Date().toISOString().split('T')[0], date_fin: '', valeur_cible: '', collectif: 0 }); setShowModal(true); }}><FiPlus /> Nouveau</button>}
            </div>

            <div className="tabs">
                <button className={`tab ${tab === 'suivi' ? 'active' : ''}`} onClick={() => setTab('suivi')}>Suivi en temps reel</button>
                <button className={`tab ${tab === 'liste' ? 'active' : ''}`} onClick={() => setTab('liste')}>Liste des objectifs</button>
            </div>

            {tab === 'suivi' && (
                <div className="objectifs-suivi">
                    {suivi.length === 0 ? <p className="text-muted">Aucun objectif en cours</p> :
                        suivi.map((obj, i) => (
                            <div key={i} className="objectif-card">
                                <div className="objectif-card-header">
                                    <span className="badge">{obj.type_activite || 'Global'}</span>
                                    <span className="badge badge-outline">{obj.periode}</span>
                                    {obj.user_nom && <span>{obj.user_nom}</span>}
                                    {obj.produit_nom && <span className="text-muted">{obj.produit_nom}</span>}
                                </div>
                                <div className="progress-container">
                                    <div className="progress-bar large">
                                        <div className="progress-fill" style={{ width: `${Math.min(100, obj.taux_atteinte || 0)}%`, backgroundColor: tauxColor(obj.taux_atteinte || 0) }}></div>
                                    </div>
                                    <div className="progress-labels">
                                        <span>{obj.valeur_realisee} / {obj.valeur_cible}</span>
                                        <span style={{ color: tauxColor(obj.taux_atteinte || 0), fontWeight: 'bold', fontSize: '1.2em' }}>{obj.taux_atteinte || 0}%</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )}

            {tab === 'liste' && (
                <div className="table-container">
                    <table className="data-table">
                        <thead><tr><th>Commercial</th><th>Type</th><th>Produit</th><th>Periode</th><th>Cible</th><th>Realise</th><th>Taux</th><th>Actions</th></tr></thead>
                        <tbody>
                            {objectifs.map(o => (
                                <tr key={o.id}>
                                    <td>{o.user_nom || 'Collectif'}</td>
                                    <td><span className="badge">{o.type_activite || 'Tout'}</span></td>
                                    <td>{o.produit_nom || '-'}</td>
                                    <td>{o.periode}</td>
                                    <td>{o.valeur_cible}</td>
                                    <td>{o.valeur_realisee}</td>
                                    <td><span style={{ color: tauxColor(o.taux_atteinte || 0), fontWeight: 'bold' }}>{o.taux_atteinte || 0}%</span></td>
                                    <td className="actions">
                                        {isManager() && <button className="btn-icon" onClick={() => { setEditObj(o); setForm({ user_id: o.user_id || '', produit_id: o.produit_id || '', type_activite: o.type_activite || '', periode: o.periode, date_debut: o.date_debut?.split('T')[0], date_fin: o.date_fin?.split('T')[0], valeur_cible: o.valeur_cible, collectif: o.collectif }); setShowModal(true); }}><FiEdit2 /></button>}
                                        {isManager() && <button className="btn-icon danger" onClick={() => handleDelete(o.id)}><FiTrash2 /></button>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()}>
                        <h3>{editObj ? 'Modifier' : 'Nouvel'} Objectif</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="form-group"><label>Commercial</label><SearchableSelect value={form.user_id} onChange={(v: string) => setForm({ ...form, user_id: v })} placeholder="Collectif" options={commerciaux.map((c: any) => ({ value: String(c.id), label: `${c.prenom} ${c.nom}` }))} /></div>
                                <div className="form-group"><label>Type activite</label><select value={form.type_activite} onChange={e => setForm({ ...form, type_activite: e.target.value })}><option value="">Tous</option>{TYPES.map(t => <option key={t} value={t}>{t}</option>)}</select></div>
                            </div>
                            <div className="form-row">
                                <div className="form-group"><label>Produit</label><select value={form.produit_id} onChange={e => setForm({ ...form, produit_id: e.target.value })}><option value="">Tous</option>{produits.map((p: any) => <option key={p.id} value={p.id}>{p.nom}</option>)}</select></div>
                                <div className="form-group"><label>Periode</label><select value={form.periode} onChange={e => setForm({ ...form, periode: e.target.value })}>{PERIODES.map(p => <option key={p} value={p}>{p}</option>)}</select></div>
                            </div>
                            <div className="form-row">
                                <div className="form-group"><label>Date debut *</label><input type="date" value={form.date_debut} onChange={e => setForm({ ...form, date_debut: e.target.value })} required /></div>
                                <div className="form-group"><label>Date fin *</label><input type="date" value={form.date_fin} onChange={e => setForm({ ...form, date_fin: e.target.value })} required /></div>
                            </div>
                            <div className="form-group"><label>Valeur cible *</label><input type="number" value={form.valeur_cible} onChange={e => setForm({ ...form, valeur_cible: e.target.value })} required /></div>
                            <label className="checkbox-label"><input type="checkbox" checked={form.collectif} onChange={e => setForm({ ...form, collectif: e.target.checked ? 1 : 0 })} /> Objectif collectif</label>
                            <div className="modal-actions">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
                                <button type="submit" className="btn btn-primary">{editObj ? 'Mettre a jour' : 'Creer'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Objectifs;
